import client from "./clients";
// import config from "./config";
//export const API = "http://localhost:5000/api";
// export const API = config.API_URL+config.prefixAPI;
export const API = `${client.config.API_URL}${client.config.prefixAPI}`;
